module.exports = __webpack_public_path__ + "img/LineOR.0992fddb.webp";